export const ACCEPT_UPLOAD_LIST =
  ".gif,.png,.jpg,.jpeg,.bmp,.mp4,.mpg,.mpeg,.mov,.avi,.mp3";
